import LandingPageForm from '../components/LandingPageForm';

export default function LaCanadaLandingPage() {
  return (
    <LandingPageForm 
      cityName="La Cañada Flintridge"
      neighborhood="La Cañada Flintridge"
      sourceTag="qr-lacanada-mailer"
    />
  );
}
